var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPvOutline(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 85 90",
    xmlns: "http://www.w3.org/2000/svg",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 1.5
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-1262,-713)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.04913,0,0,1.86899,197.157,-1135.9)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.90301,0,0,0.534882,24.446,774.066)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "pv"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.374377,0,0,0.374377,620.991,212.56)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 1391.76,
    cy: 630.663,
    r: 50.977,
    style: {
      fill: "rgb(255,167,0)",
      stroke: "rgb(255,167,0)",
      strokeWidth: "5.49px"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.374377,0,0,0.374377,620.576,216.549)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1315.11,697.37L1345.13,671.939",
    style: {
      fill: "none",
      stroke: "rgb(255,167,0)",
      strokeWidth: "10.97px"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.374377,0,0,0.374377,668.794,168.332)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1315.11,697.37L1345.13,671.939",
    style: {
      fill: "none",
      stroke: "rgb(255,167,0)",
      strokeWidth: "10.97px"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.242011,-0.327005,0.285637,0.277061,624.414,726.703)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1315.11,697.37L1345.13,671.939",
    style: {
      fill: "none",
      stroke: "rgb(255,167,0)",
      strokeWidth: "11.26px"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.373581,-0.0724153,0.0801265,0.368757,574.285,315.638)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1324.45,594.556L1302.06,578.998",
    style: {
      fill: "none",
      stroke: "rgb(255,167,0)",
      strokeWidth: "10.84px"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-0.373581,-0.0724153,-0.0801265,0.368757,1708.86,317.696)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1324.45,594.556L1302.06,578.998",
    style: {
      fill: "none",
      stroke: "rgb(255,167,0)",
      strokeWidth: "10.84px"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.0724153,0.373581,-0.368757,0.0801265,1274.94,-117.454)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1324.45,594.556L1302.06,578.998",
    style: {
      fill: "none",
      stroke: "rgb(255,167,0)",
      strokeWidth: "10.6px"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.0724153,-0.373581,-0.368757,-0.0801265,1274.94,1013.48)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1324.45,594.556L1302.06,578.998",
    style: {
      fill: "none",
      stroke: "rgb(255,167,0)",
      strokeWidth: "10.6px"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.20298,-0.30791,0.30596,0.211055,665.966,741.292)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1324.45,594.556L1302.06,578.998",
    style: {
      fill: "none",
      stroke: "rgb(255,167,0)",
      strokeWidth: "11.5px"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-0.20298,-0.30791,-0.30596,0.211055,1617.18,743.349)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1324.45,594.556L1302.06,578.998",
    style: {
      fill: "none",
      stroke: "rgb(255,167,0)",
      strokeWidth: "11.5px"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.30791,0.20298,-0.211055,0.30596,849.288,-25.7725)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1324.45,594.556L1302.06,578.998",
    style: {
      fill: "none",
      stroke: "rgb(255,167,0)",
      strokeWidth: "10.94px"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.30791,-0.20298,-0.211055,-0.30596,849.288,921.794)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1324.45,594.556L1302.06,578.998",
    style: {
      fill: "none",
      stroke: "rgb(255,167,0)",
      strokeWidth: "10.94px"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-0.213857,-0.274055,0.202995,0.118272,1310.92,756.558)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1315.11,697.37L1345.13,671.939",
    style: {
      fill: "none",
      stroke: "rgb(255,167,0)",
      strokeWidth: "36.24px"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-0.352561,-0.29797,0.247113,-0.351683,1474.98,1085.78)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1315.11,697.37L1345.13,671.939",
    style: {
      fill: "none",
      stroke: "rgb(255,167,0)",
      strokeWidth: "8.61px"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-0.309582,0.378991,-0.365389,-0.339628,1803.83,143.068)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1315.11,697.37L1345.13,671.939",
    style: {
      fill: "none",
      stroke: "rgb(255,167,0)",
      strokeWidth: "8.83px"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-0.224789,0.494312,-0.408911,-0.239181,1699.69,-72.2875)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1335.5,712.738L1345.13,671.939",
    style: {
      fill: "none",
      stroke: "rgb(255,167,0)",
      strokeWidth: "8.67px"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.36273,0.350747,-0.231135,0.413974,783.809,-301.298)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1315.11,697.37L1345.13,671.939",
    style: {
      fill: "none",
      stroke: "rgb(255,167,0)",
      strokeWidth: "7.3px"
    }
  }))))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPvOutline);
export default __webpack_public_path__ + "static/media/pvOutline.18036b9ea198f84e19f87ba8b523d9c5.svg";
export { ForwardRef as ReactComponent };